import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import Picture from '../../../../components/Picture';

export const photoProportionAspectRatio = (photoProportion) => {
  if (photoProportion === 'portrait') {
    return '5 / 7'; // based on FWM's uploaded FR profile photo dimensions: 400x560
  } else if (photoProportion === 'square') {
    return '1 / 1';
  }
  return 'auto';
};

export const commonAgentPhotoStyles = (agentDisplayVariant, photoProportion, theme) => {
  const mediumUp = theme.mediumUp();
  const smallUp = theme.smallUp();
  let thisWidth = '100%';
  let thisHeight = 'auto';
  if (agentDisplayVariant === 'financialAdvisorMatch') {
    if (mediumUp) {
      thisWidth = '20vw';
      thisHeight = '20vw';
    } else if (smallUp) {
      thisWidth = rem(200);
      thisHeight = rem(200);
    }
  }
  return css`
    display: flex;
    width: ${thisWidth};
    max-width: ${rem(200)};
    height: ${thisHeight};
    ${agentDisplayVariant === 'financialAdvisorMatch' && css`max-height: ${rem(200)}`};
    margin: ${mediumUp ? `0 auto ${rem(40)}` : `0 auto ${rem(24)}`};
    ${photoProportion && css`aspect-ratio: ${photoProportionAspectRatio(photoProportion)};`};
    flex-wrap: wrap;
    overflow: hidden;
    justify-content: center;
  `;
};

export const PictureStyled = styled(Picture)`
  ${({ agentDisplayVariant, photoProportion, theme }) => css`
    ${commonAgentPhotoStyles(agentDisplayVariant, photoProportion, theme)};
    ${photoProportion === 'portrait' && css`
      /** additional portrait styles */
      position: relative;
      overflow: hidden;
      .aura-picture {
        height: 100%;
        object-fit: cover;
        object-position: top;
      }
    `};
  `}
`;

export const DivStyledAgentInitials = styled.div`
  ${({ agentDisplayVariant, photoProportion, theme }) => css`
    ${commonAgentPhotoStyles(agentDisplayVariant, photoProportion, theme)};
  `}
`;

export const SpanStyledAgentPlaceholderInitials = styled.span`
  ${({ photoProportion, theme }) => {
    const mediumUp = theme.mediumUp();

    return css`
      position: relative; /** needed for AgentInitials prependPictureChildren positioning */
      display: flex;
      width: 100%;
      padding-top: ${rem(8)};
      align-items: center;
      justify-content: center;
      ${photoProportion && css`aspect-ratio: ${photoProportionAspectRatio(photoProportion)};`};
      font-size: ${mediumUp ? rem(48) : rem(32)};
      font-weight: 500;
      text-transform: uppercase;
      color: ${theme.colors.blue.blue};
      background-color: ${theme.colors.sky.skyDark10};
    `;
  }}
`;
